import { AirbrakeService } from '@shared/ui';

import { ErrorHandler, inject } from '@angular/core';

export class AirbrakeErrorHandler implements ErrorHandler {
  private readonly airbrakeService = inject(AirbrakeService);

  handleError(error: unknown): void {
    this.airbrakeService.errorHandler(error);
  }
}
